const ITEMS = ["Hair", "Colour", "Keratin", "Braids", "Makeup", "Bridal", "Waxing", "Styling"];

export default function Marquee({ dark = true }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className={`overflow-hidden border-y select-none ${
        dark ? "border-ivory/10 bg-ink text-ivory/70" : "border-charcoal/10 bg-cream text-charcoal/60"
      }`}
    >
      <div className="animate-marquee flex w-max items-center py-3.5">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-lg italic tracking-wide px-6">{item}</span>
                <span className={`h-1 w-1 rounded-full ${dark ? "bg-champagne/60" : "bg-rose/50"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
